import { useMediaQuery } from '@dni-react-hooks/use-media-query'
import { type DesktopMediaQuery, type MobileMediaQuery, type TabletMediaQuery, type WordPressMobileMediaQuery, type WordPressTabletMediaQuery } from '../tokens/breakpoints.stylex'
import { parseMediaQuery } from '../utils/parseMediaQuery'

const MOBILE: MobileMediaQuery = '@media (max-width: 480px)'
const TABLET: TabletMediaQuery = '@media (min-width: 481px) and (max-width: 1280px)'
const DESKTOP: DesktopMediaQuery = '@media (min-width: 1281px)'
const WORDPRESS_TABLET: WordPressTabletMediaQuery = '@media (min-width: 961px)'
const WORDPRESS_MOBILE: WordPressMobileMediaQuery = '@media (max-width: 960px)'

export const conditions = {
  mobile: parseMediaQuery(MOBILE),
  tablet: parseMediaQuery(TABLET),
  desktop: parseMediaQuery(DESKTOP),

  /**
   * WordPress 客製化寬度
   * @deprecated 新的設計不會使用到這個斷點
   */
  wordPressTablet: parseMediaQuery(WORDPRESS_TABLET),
  /**
   * WordPress 客製化寬度
   * @deprecated 新的設計不會使用到這個斷點
   */
  wordpressMobile: parseMediaQuery(WORDPRESS_MOBILE),
}

export const useResponsive = (condition: keyof typeof conditions) => {
  return useMediaQuery(conditions[condition])
}

/**
 * 自定義斷點
 * @param condition 自定義斷點
 * @returns 是否符合斷點
 */
export const useResponsiveCustom = (condition: string) => {
  return useMediaQuery(parseMediaQuery(condition))
}
